import { faLayerGroup, faLeaf } from "@fortawesome/free-solid-svg-icons";
import ViewLayerRaster from "./ViewLayerRaster";
import SubHeader from "../Shared/SubHeader";
import { MapType, SelectedLayersType } from "../../types/dataTypes";
import { SubContainerStyle } from "../../styles/styles";
import { TEXT_FILTER } from "../../utils/text";
import ViewLayerVector from "./ViewLayerVector";
import styled from '@emotion/styled';

type ViewLayerGroupProps = {
  map: MapType;
  selectedLayers: SelectedLayersType[];
  setSelectedLayers: Function;
};

function ViewLayerGroup({ map, selectedLayers, setSelectedLayers }: ViewLayerGroupProps) {
  const rasterLayers = selectedLayers.filter((layer: SelectedLayersType) => layer.type === 'raster');
  const nonRasterLayers = selectedLayers.filter((layer: SelectedLayersType) => layer.type !== 'raster' && layer.layerId !== 'survey');

  return (
    <>  
        <SubHeader text={'Show Layers'} icon={faLayerGroup} />
        <SubContainerStyle>
          {nonRasterLayers.map((layer) => (
            <ViewLayerVector
              key={layer.layerId}
              layerId={layer.layerId}
              layerIdArray={[layer.layerId]}
              layerName={layer.layerName}
              toolTipText={layer.toolTipText}
              map={map}
              toggleInit={layer.isSelected}
              isMarker={layer && layer.type === 'marker'}
              markerClass={layer.markerClass}
              setSelectedLayers={setSelectedLayers}
            />
          ))}      
        </SubContainerStyle>
        <DivBreakStyle />
        <SubHeader text={TEXT_FILTER.VIEW_LAYERS_IS_RASTER} icon={faLeaf} />
        <SubContainerStyle>        
        <ViewLayerRaster
          map={map}
          rasterLayers={rasterLayers}
          setSelectedLayers={setSelectedLayers}
        />
        </SubContainerStyle>
    </>
  );
}

export default ViewLayerGroup;

const DivBreakStyle = styled.div<{}>(() => `
  height: 40px;
`);
